export default __webpack_public_path__ + "static/media/EM0680.34I-22030_-15020_0.2e5eb1d4.jpg";